import React from 'react';
import { useParams } from 'react-router-dom';
import { Offers } from '../Offer';
import './offerpage.css';
import Navbar from '../../Navbar/Navbar'

const OfferPage = () => {
  const { id } = useParams();

  const offer = Offers.find(offer => offer.id === parseInt(id));

  return (
    <>
    <Navbar/>
    <div className='offerContainer'>
      <div className="cardContent grid">
        <div className="offer-info">
          <div className='imgContainer'>
            <img src={offer.imgSrc} alt={offer.destTitle} className="offer-image" />
          </div>
          <div className="offer-description">
            <h3 className="offer-name">{offer.destTitle}</h3>
            <h4 className="offer-desc">{offer.desc}</h4>
            <p className="offer-text">{offer.text}</p>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default OfferPage;

